import { useAppDispatch, useAppSelector } from '@/state/store';
import { setDiscordMobileShareUrl } from '@/state/features/app';
import Modal from '@/components/Modal';
import ThemedButton from '@/components/ThemedButton';
import { openImageInDiscordBrowser } from '@/components/DiscordAuthFlow/useDiscord';
import { useUITranslatedText } from '@/components/TranslatedText';

export default function DiscordMobileShareModal() {
    const dispatch = useAppDispatch();
    const discordMobileShareUrl = useAppSelector((state) => state.app.discordMobileShareUrl);
    const translation_title = useUITranslatedText('discordMobileShare_title', 'Share your image');
    const translation_body = useUITranslatedText(
        'discordMobileShare_body',
        'Long press the image and select Copy, then share with friends.',
    );
    const translation_continue = useUITranslatedText('discordMobileShare_continue', 'Continue');

    return (
        <Modal
            isVisible={!!discordMobileShareUrl}
            onClose={() => dispatch(setDiscordMobileShareUrl(null))}
            hasCloseButton={false}
            title={translation_title}
        >
            <p style={{ marginBottom: '10px' }}>{translation_body}</p>
            <ThemedButton
                text={translation_continue}
                onClick={() => {
                    openImageInDiscordBrowser(discordMobileShareUrl!.imageUrl, discordMobileShareUrl!.filename);
                    dispatch(setDiscordMobileShareUrl(null));
                }}
            />
        </Modal>
    );
}
